import { useState } from 'react';

/**
 * <Exercise label="Exercise 1" difficulty="★">
 *   <p className="prompt">Prompt text...</p>
 *   <Solution>The solution.</Solution>
 * </Exercise>
 */
export function Exercise({ label, difficulty = '', children }) {
  return (
    <div className="exercise-card">
      <div className="flex justify-between items-baseline mb-2 pb-2 border-b border-dotted border-rule font-mono text-[10px] uppercase tracking-[0.25em] text-accent">
        <span>{label}</span>
        <span className="text-ink-muted text-[9px]">{difficulty}</span>
      </div>
      <div className="text-[1.02rem]">{children}</div>
    </div>
  );
}

export function Solution({ summary = 'Show solution', children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-t border-dashed border-rule pt-2 mt-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent py-1 cursor-pointer bg-transparent border-0 hover:text-ink"
      >
        {open ? '▾ ' : '▸ '}{summary}
      </button>
      {open && (
        <div className="mt-3 p-4 bg-paper-warm border-l-2 border-accent text-[0.98rem]">
          {children}
        </div>
      )}
    </div>
  );
}
